import {
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import { Fragment } from "react/jsx-runtime";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ViewIcon from "../../../../../assets/images/icons/view.svg";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import API from "../../../../api/axios";
import moment from "moment";
import { getUser } from "../../../../utils/types";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../store/slices/toastSlice";
import AutoRescheduleDialog from "../../../../shared/AutoReschedule/AutoRescheduleDialog";
import DataLoader from "../../../../shared/DataLoader/DataLoader";
import CompareIcon from "@mui/icons-material/Compare";
import HandleInterviewLink, { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";
import ViewIcons from "./../../../../assets/images/icons/view.svg";
import CloseIcon from "@mui/icons-material/Close";
import ConfirmationDialog from "../../../../components/ConfirmationDialog/ConfirmationDialog";



const InterviewTrackerView = () => {
  const [interviewerInfo, setInterviewerInfo] = useState<any>({});
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const state = useLocation();
  const loggedUserdata = getUser();
  const isReschedulingTracker = state.pathname?.includes("rescheduling-tracker");
  const [isRescheduleDialogOpen, setIsRescheduleDialogOpen] = useState(false);
  const [isRescheduleloading, setIsRescheduleloading] = useState(false);
  const [cancelHoldOpen, setCancelHoldOpen] = useState(false);
  const [cancelHoldLoading, setCancelHoldLoading] = useState(false);
  const [rescheduleData, setRescheduleData] = useState<any>([]);
  const [autoReschedleTimeExceeds, setAutoRescheduleTimeExceeds] =
    useState<boolean>(false);
  const [interviewCompleted, setInterviewCompleted] = useState<boolean>(false);
  const [remarksModelOpen, setRemarksModelOpen] = useState<boolean>(false);
  const [remarkInterviewerConsent, setRemarksInterviewerConsent] =
    useState<string>("");
  const [interviewerRemarks, setInterviwerRemarks] = useState<string>("");
  const [remarksInterviewerName, setRemarksInterviewerName] =
    useState<string>("");
  const [rescheduleDataLoding, setRescheduleDataLoading] =
    useState<boolean>(false);
  const [markAttendanceOpen, setMarkAttendanceOpen] = useState(false);
  const [markAttendanceStatus, setMarkAttendanceStatus] = useState<"completed" | "rescheduling" | "rescheduling_cancel" | null>(null);
  const [markAttendanceLoading, setMarkAttendanceLoading] = useState(false);
  const [resetForm, setResetForm] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  // console.log(
  //   "interview info",
  //   interviewerInfo?.scheduled_applications?.[0]?.interview_panel
  // );
  // console.log("interview completed", interviewCompleted);

  const breadcrumbs: BreadcrumbsModel[] = [
    {
      name: isReschedulingTracker ? "Rescheduling Tracker" : "Interview tracker",
      route: isReschedulingTracker
        ? "/admin/rescheduling-tracker"
        : "/admin/interview-tracker",
    },
    { name: "View" },
  ];

  const handleCloseRemarksModel = () => {
    setRemarksModelOpen(false);
  };

  const getInterviewData = async () => {
    setDataLoading(true);
    try {
      let response = await API.post("/positions/all/applied", {
        offset: 0,
        limit: -1,
        applicationID: id,
      });
      setInterviewerInfo(response?.data?.data[0]);
    } catch (error) {
      // Failed to fetch interview view data
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    getInterviewData();
  }, [id]);

  const formatTime = (startTime: any, endTime: any) => {
    if (startTime === "NA") {
      return "NA";
    }

    return `${moment(startTime, "HH:mm:ss").format("hh:mm A")} - ${moment(
      endTime,
      "HH:mm:ss"
    ).format("hh:mm A")}`;
  };

  const checkInterviewerName = (interviewers: any) => {
    const hasValidInterviewer = interviewers?.some(
      (interviewer: any) =>
        interviewer?.interviewer_name !== null &&
        interviewer?.interviewer_name !== undefined
    );

    return hasValidInterviewer
      ? interviewers?.map((val: any, index: number) => {
          return <Box>{`${index + 1}. ${val?.interviewer_name || "NA"}`}</Box>;
        })
      : "NA";
  };

  const renderAttendeeEmails = (attendeesStr: any) => {
    try {
      if (!attendeesStr) return "NA";
      const attendees =
        typeof attendeesStr === "string"
          ? JSON.parse(attendeesStr)
          : attendeesStr;

      if (Array.isArray(attendees) && attendees.length > 0) {
        return attendees.map((val: any, index: number) => {
          const email = val?.email || "NA";
          const displayName = val?.displayName;
          const displayStr =
            displayName && displayName !== email
              ? `${email} (${displayName})`
              : email;
          return <Box sx={{color: !val?.system_email ? 'red' : 'inherit'}} key={index}>{`${index + 1}. ${displayStr}`}</Box>;
        });
      }
    } catch (error) {
      // Failed to parse attendee emails
    }
    return "NA";
  };

  function isTimeWithinTenMinutes(passedDate: any, passedTime: any) {
    const passedDateTime = passedDate + " " + passedTime;
    const passedMoment = moment(passedDateTime, "YYYY-MM-DD HH:mm:ss");
    const currentMoment = moment();
    const differenceInMinutes = passedMoment.diff(currentMoment, "minutes");
    if (passedMoment.isBefore(currentMoment)) {
      setInterviewCompleted(true);
      return true;
    }
    return differenceInMinutes <= 10;
  }

  const handleRescheduleConfirm = async (data?: any) => {
    setIsRescheduleloading(true);
    try {
      let response = await API.post("/reschedule/interview/request", {
        application_id: interviewerInfo?.id,
        schedule_id: interviewerInfo?.scheduled_applications[0]?.id,
        reason: data?.reason,
      });
      if (response?.statusText == "OK" || response?.status == 200) {
        dispatch(
          setToast({
            message: response?.data?.message,
            severity: "success",
            open: true,
          })
        );
        setResetForm(true);
        setIsRescheduleDialogOpen(false);
        getLatestRescheduleRequest();
      }
    } catch (error) {
      // console.log("Auto Reschedule Error", error);
    } finally {
      setIsRescheduleloading(false);
    }
  };

  const handleRescheduleClick = (data: any) => {
    setIsRescheduleDialogOpen(true);
  };

  const handleRescheduleCancel = () => {
    setIsRescheduleDialogOpen(false);
  };

  const handleCancelHold = async () => {
    if (!interviewerInfo?.id) return;

    setCancelHoldLoading(true);
    try {
      const response = await API.post("/interview/cancel-and-hold", {
        application_id: interviewerInfo.id,
      });

      if (response?.status === 200 || response?.statusText === "OK") {
        dispatch(
          setToast({
            message: response?.data?.message || "Interview cancelled and held successfully",
            severity: "success",
            open: true,
          })
        );
        getInterviewData();
        getLatestRescheduleRequest();
      }
    } catch (error: any) {
      dispatch(
        setToast({
          message: error?.response?.data?.errors?.[0]?.message || "Failed to cancel and hold interview",
          severity: "error",
          open: true,
        })
      );
    } finally {
      setCancelHoldLoading(false);
      setCancelHoldOpen(false);
    }
  };

  const handleMarkAttendance = async () => {
    if (!markAttendanceStatus || !interviewerInfo?.id) return;

    setMarkAttendanceLoading(true);
    try {
      const response = await API.post("/interview/mark-attendance", {
        application_id: interviewerInfo.id,
        status: markAttendanceStatus,
      });

      if (response?.status === 200 || response?.statusText === "OK") {
        dispatch(
          setToast({
            message: response?.data?.message || `Interview marked as ${markAttendanceStatus} successfully`,
            severity: "success",
            open: true,
          })
        );
        
        const basePath = isReschedulingTracker ? "/admin/rescheduling-tracker" : "/admin/interview-tracker";
        navigate(basePath);
      }
    } catch (error: any) {
      dispatch(
        setToast({
          message: error?.response?.data?.errors?.[0]?.message || "Failed to mark attendance",
          severity: "error",
          open: true,
        })
      );
    } finally {
      setMarkAttendanceLoading(false);
      setMarkAttendanceOpen(false);
      setMarkAttendanceStatus(null);
    }
  };

  const getLatestRescheduleRequest = async () => {
    setRescheduleDataLoading(true);
    try {
      if (interviewerInfo?.scheduled_applications?.length > 0) {
        let response = await API.get(
          `/items/interview_reschedule_requests?fields=*&filter[status]=published&sort[]=-id&limit=1&filter[application_id]=${interviewerInfo?.id}&filter[reshedule_status]=pending&filter[schedule_id]=${interviewerInfo?.scheduled_applications[0]?.id}`
        );
        setRescheduleData(response?.data?.data);
      }
    } catch (err) {
      // Failed to fetch latest reschedule request
    } finally {
      setRescheduleDataLoading(false);
    }
  };

  useEffect(() => {
    getLatestRescheduleRequest();
    if (interviewerInfo?.scheduled_applications?.length > 0) {
      setAutoRescheduleTimeExceeds(
        isTimeWithinTenMinutes(
          interviewerInfo?.scheduled_applications[0]?.slot_date,
          interviewerInfo?.scheduled_applications[0]?.start_time
        )
      );
    }
  }, [interviewerInfo]);

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title={isReschedulingTracker ? "Rescheduling Tracker" : "Interview Tracker"}>
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() =>
            navigate(isReschedulingTracker ? "/admin/rescheduling-tracker" : "/admin/interview-tracker", {
              state: state?.state,
            })
          }
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        {dataLoading || rescheduleDataLoding ? (
          <Box height={"400px"}>
            <DataLoader />
          </Box>
        ) : (
          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Candidate Name</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.candidate_name || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Email</Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ wordBreak: "break-word" }}
                >
                  {interviewerInfo?.candidate_email || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Mobile</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.candidate_mobile || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Position Title</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.position_name || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Position Status</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.application_display_status || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Applied Date</Typography>
                <Typography variant="subtitle2">
                  {!!interviewerInfo?.application_date
                    ? handleDate(interviewerInfo?.application_date)
                    : "NA"}
                </Typography>
              </Grid2>
              {/* <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
                <Typography variant="body1">Invite Title</Typography>
                <Typography variant="subtitle2">HR Round static</Typography>
              </Grid2> */}
              {interviewerInfo?.scheduled_applications?.length > 0 && (
                <>
                  <Grid2
                    size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Interview Date</Typography>
                    <Typography variant="subtitle2">
                      {!!interviewerInfo?.scheduled_applications[0]?.slot_date
                        ? handleDate( interviewerInfo?.scheduled_applications[0]?.slot_date)
                        : "NA"}
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Interview Time</Typography>
                    <Typography variant="subtitle2">
                      {formatTime(
                        interviewerInfo?.scheduled_applications[0]
                          ?.start_time || "NA",
                        interviewerInfo?.scheduled_applications[0]?.end_time
                      )}
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Panel Name</Typography>
                    <Typography variant="subtitle2">
                      {checkInterviewerName(
                        interviewerInfo?.scheduled_applications[0]
                          ?.interview_panel
                      )}
                    </Typography>
                  </Grid2>
                </>
              )}
              {interviewerInfo?.scheduled_applications?.length > 0 && (
                <>
                  <Grid2
                    size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Interview Link</Typography>
                    <Typography variant="subtitle2">
                      <HandleInterviewLink
                        link={
                          interviewerInfo?.scheduled_applications[0]?.webex_link
                        }
                      />
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Interview Password</Typography>
                    <Typography variant="subtitle2">
                      {interviewerInfo?.scheduled_applications[0]
                        ?.webex_meeting_password || "NA"}
                    </Typography>
                  </Grid2>
                </>
              )}
              <Grid2
                size={{
                  xs:
                    interviewerInfo?.scheduled_applications?.length > 0
                      ? 6
                      : 12,
                }}
                marginBottom={4}
              >
                <Typography variant="body1">Description</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.additional_notes}
                </Typography>
              </Grid2>
              <Grid2
                size={{
                  xs:
                    interviewerInfo?.scheduled_applications?.length > 0
                      ? 6
                      : 12,
                }}
                marginBottom={4}
              >
                <Typography variant="body1">Remarks</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.issue_notes || "NA"}
                </Typography>
              </Grid2>
               
               {!isReschedulingTracker && (
                <>
                {interviewerInfo?.scheduled_applications?.length > 0 && (
                <Grid2 size={{ xs: 12 }} marginBottom={4}>
                  <Box sx={{ display: "flex", gap: "40px" }}>
                    {interviewerInfo?.scheduled_applications[0]?.interview_panel?.map(
                      (interviewer: any, index: any) => {
                        return <Grid2 size={{ xs: 3 }}>
                           <Typography variant="body1">
                     {`${interviewer?.interviewer_name} Consent`}
                    </Typography> 
                    <Typography variant="subtitle2">
                      {!interviewer?.interview_consent_time?"NA":interviewer?.is_interview_completed?"Yes":  <>
                        {"No"}
                        <Tooltip title="View Remarks" arrow>
                          <IconButton
                            size="small"
                            sx={{ fontSize: "14px", color: "#4880FF" }}
                            className="table__icons"
                            onClick={() =>{
                              setRemarksInterviewerConsent("No");
                              setRemarksInterviewerName(interviewer?.interviewer_name);
                              setInterviwerRemarks(interviewer?.interview_remarks);
                              setRemarksModelOpen(true);
                            }
                              
                            }
                          >
                            <img src={ViewIcons} style={{ width: "20px" }} />
                          </IconButton>
                        </Tooltip>
                      </>}
                    </Typography>
                    
                        </Grid2>;
                      }
                    )}
                  </Box>
                  
                </Grid2>
              )}
              </>
               )}
              
             
              {isReschedulingTracker && (
                <>
                 <Grid2 size={{ xs: 12 }} marginBottom={4}>
                <Typography variant="body1">Interview Attendees</Typography>
                <Typography variant="subtitle2">
                  {renderAttendeeEmails(
                    interviewerInfo?.scheduled_applications?.[0]
                      ?.interview_attendee
                  )}
                </Typography>
              </Grid2>
                <Grid2 sx={{display: "flex", gap: "10px"}}>
                  {interviewerInfo?.application_status !== "interview_hold" && interviewerInfo?.application_status !== "reschedule_failed" && interviewerInfo?.application_status !== "rescheduling_cancel" && (
                    <Button
                  variant="secondary"
                  variantType="contained"
                  label="Mark as completed"
                  onClick={() => {
                    setMarkAttendanceStatus("completed");
                    setMarkAttendanceOpen(true);
                  }}
                />

                  )}
                 <Button
                  variant="secondary"
                  variantType="outlined"
                  label="Reschedule"
                  onClick={() => {
                    setMarkAttendanceStatus("rescheduling");
                    setMarkAttendanceOpen(true);
                  }}
                />   
                {interviewerInfo?.application_status !== "rescheduling_cancel" && (
                  <Button
                  variant="secondary"
                  variantType="contained"
                  label="Cancel Rescheduling"
                  onClick={() => {
                    setMarkAttendanceStatus("rescheduling_cancel");
                    setMarkAttendanceOpen(true);
                  }}
                />  
                )}
              </Grid2>
              </>
              )}
              <Grid2 size={{ xs: 12 }}>
                {loggedUserdata?.roles?.role_code !== "administrator" &&
                  (interviewerInfo?.application_status == "scheduled" ||
                    interviewerInfo?.application_status == "rescheduling_cancel") &&
                  !interviewCompleted && (
                    <>
                      <Divider sx={{ marginTop: "30px" }} />
                      <Box sx={{ marginTop: "30px", display: "flex", gap: "10px", alignItems: "center" }}>
                        <Tooltip
                          title={`${
                            autoReschedleTimeExceeds
                              ? "The interview is scheduled to begin in the next 10 minutes. Rescheduling is no longer possible at this time."
                              : interviewerInfo?.scheduled_applications
                                  ?.length <= 0
                              ? "Interview not scheduled"
                              : rescheduleData?.length > 0
                              ? `A reschedule request for this interview was already generated by an admin on ${moment(
                                  rescheduleData[0]?.date_created
                                ).format("DD-MM-YYYY")}`
                              : "Auto Reschedule"
                          }`}
                          arrow
                        >
                            <Button
                              disabled={
                                interviewerInfo?.scheduled_applications
                                  ?.length <= 0 ||
                                rescheduleData?.length > 0 ||
                                autoReschedleTimeExceeds
                              }
                              variant="secondary"
                              variantType="contained"
                              label="Auto Reschedule"
                              onClick={() => handleRescheduleClick({ ...state, rescheduleData })}
                            />
                        </Tooltip>
                              {interviewerInfo?.application_status == "scheduled" && (
                              <Button
                              disabled={
                                interviewerInfo?.scheduled_applications?.length <= 0 ||
                                rescheduleData?.length > 0
                              }
                              variant="secondary"
                              variantType="outlined"
                              label="Cancel and Hold"
                              onClick={() => setCancelHoldOpen(true)}
                            />
                              )}
                      </Box>
                      {(interviewerInfo?.scheduled_applications?.length <= 0 ||
                        rescheduleData?.length > 0) && (
                        <Typography
                          variant="subtitle2"
                          sx={{
                            marginTop: "10px",
                            marginLeft: "10px",
                            color: "red",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          Note :
                          {interviewerInfo?.scheduled_applications?.length <= 0
                            ? " Interview not scheduled"
                            : ` A reschedule request for this interview was already generated by an admin on ${moment(
                                rescheduleData[0]?.date_created
                              ).format("DD-MM-YYYY")}`}{" "}
                        </Typography>
                      )}
                    </>
                  )}
              </Grid2>
            </Grid2>
            <AutoRescheduleDialog
              open={isRescheduleDialogOpen}
              onClose={handleRescheduleCancel}
              onConfirm={handleRescheduleConfirm}
              loading={isRescheduleloading}
              resetForm={resetForm}
            />

            {remarksModelOpen && (
              <RemarksModal
                open={remarksModelOpen}
                onClose={handleCloseRemarksModel}
                name={remarksInterviewerName}
                consent={remarkInterviewerConsent}
                remarks={interviewerRemarks}
              />
            )}

            <ConfirmationDialog
              open={markAttendanceOpen}
              loading={markAttendanceLoading}
              title={
                markAttendanceStatus === "completed"
                  ? "Mark as Completed"
                  : markAttendanceStatus === "rescheduling"
                  ? "Reschedule"
                  : "Cancel Rescheduling"
              }
              summary={`Are you sure you want to ${
                markAttendanceStatus === "completed"
                  ? "mark this interview as completed"
                  : markAttendanceStatus === "rescheduling"
                  ? "mark this interview for rescheduling"
                  : "cancel the rescheduling request for this interview"
              }?`}
              onClose={() => {
                setMarkAttendanceOpen(false);
                setMarkAttendanceStatus(null);
              }}
              onConfirm={handleMarkAttendance}
            />

            <ConfirmationDialog
              open={cancelHoldOpen}
              loading={cancelHoldLoading}
              title="Cancel and Hold"
              summary="Are you sure you want to cancel and hold this interview?"
              onClose={() => {
                setCancelHoldOpen(false);
              }}
              onConfirm={handleCancelHold}
            />
          </CardContent>
        )}
      </Card>
    </PageWrapper>
  );
};
export default InterviewTrackerView;

export const RemarksModal = ({
  open,
  onClose,
  name,
  consent,
  remarks,
}: any) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: "15px",
        },
      }}
    >
      <DialogTitle
        sx={{
          borderBottom: "solid 1px #ddd",
          position: "relative",
          fontSize: { xs: "1rem", md: "1.25rem" },
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: "#202224",
              fontSize: { xs: "1rem", md: "1.25rem" },
              fontStyle: "normal",
              fontWeight: "600",
              letterSpacing: "0.3px",
            }}
          >
            Interviewer Consent
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: { xs: "-15px", md: "-20px" },
            top: { xs: "-15px", md: "-20px" },
            height: { xs: "34px", md: "44px" },
            width: { xs: "34px", md: "44px" },
            color: "#FB8B0E",
            border: "2px solid #FB8B0E",
            borderRadius: "50% !important",
            padding: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Box
            sx={{ display: "flex", gap: "9em", marginBottom: 4, marginTop: 2 }}
          >
            <Box>
              <Typography variant="body1">InterviewerName Consent</Typography>
              <Typography variant="subtitle2">{name}</Typography>
            </Box>
            <Box>
              <Typography variant="body1">Interviewer Consent</Typography>
              <Typography variant="subtitle2">{consent}</Typography>
            </Box>
          </Box>

          <Typography variant="body1">Interviewer Remarks</Typography>
          <Typography variant="subtitle2">{remarks}</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
